import { User } from 'firebase/auth';
import {createContext} from 'react';

export type ContextType = User | null;

export const UserContext = createContext<null | { userState: ContextType; setUserState: React.Dispatch<React.SetStateAction<ContextType>>}>(null);